import { localizeDigits, parseLocalizedNumber } from "../../../features/store-language/i18n.ts";

export default function formatDimension(value: string): string {
  const parts = value.split(/[*×x]/i).map(function (part) { return part.trim(); });
  if (parts.length === 2 && parts.every(function (part) { return Number.isFinite(parseLocalizedNumber(part)); })) {
    // Isolated LTR output keeps the larger length physically on the right.
    parts.sort(function (left, right) { return parseLocalizedNumber(left) - parseLocalizedNumber(right); });
    return localizeDigits(parts.join(" × "));
  }
  return localizeDigits(value);
}
